
import React, { Component } from 'react';
import perfil from '../assets/img/perfil.svg';

export default class ListaEestudiante extends Component {
  render() {
    const student = this.props.objStudents;
    return (
      <div className="lista-estudiante-card">
        {/* <img className="background-perfil" src={perfil} /> */}
        {student.Foto == "" ? (
          <img className="background-perfil" src={perfil} />
        ) : (
          <img
            className="background-perfil"
            style={{
              width: "100px",
              height: "100px",
              border: "1px solid #21252930",
              background: "#fff",
              borderRadius: "0px",
            }}
            src={student.Foto}
          />
        )}
        <div className="lista-contend-card">
          <h1
            className="nombre-estudiante"
            style={{ textTransform: "capitalize" }}
          >
            {student == undefined ? "" : student.Nombres}
          </h1>
          <h1 className="carrera-estudiante">
            {student == undefined ? "" : student.Carrera}
          </h1>
          <h1 className="codigo-estudiante">
            {student == undefined ? "" : student.Codigo}
          </h1>
        </div>
      </div>
    );
  }
}
